<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="examLevel" clearable placeholder="请选择考试等级">
              <el-option
                v-for="item in ExamLevelList"
                :key="item.value"
                :label="item.value"
                :value="item.lable"
              ></el-option>
            </el-select>
        </el-form-item>
         <el-form-item>
        <el-select v-model="ExamDateId" clearable placeholder="请选择考试时间">
            <el-option
              v-for="item in ExamDateList"
              :key="item.StartTime"
              :label="item.StartTime"
              :value="item.Id"
              ></el-option>
            </el-select>
         </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="seatchSchoolList()">搜索</el-button>
          <el-button type="primary" icon="el-icon-search" @click="goExamTime()">考试批次管理</el-button>
           <el-button type="primary" icon="el-icon-search" @click="getLog()">查看考试日志</el-button>
          <a class="export-button-a" style="color:#fff;margin-left:10px;" :href="exportExam">导出</a>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="siteList">
         <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
           <el-table-column prop="CreateUserName" label="创建用户名"></el-table-column>
        <el-table-column prop="SchoolName" label="单位名称"></el-table-column>
        <el-table-column  label="单位地址">
          <template slot-scope="scope" > 
             <!-- <p v-if="scope.row.OperationType !='删除考试'"> <span>{{scope.row.StudentNumber}}</span></p>
             <span v-else>--</span> -->
             <span>{{scope.row.Province}}{{scope.row.City}}{{scope.row.Area}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="StudentNumber" label="考试人数"></el-table-column>
        <el-table-column prop="ExamDate" label="考试时间"></el-table-column>
        <el-table-column prop="ExamLevel" label="考试等级">
            <template slot-scope="scope">
              <span>{{ExamLevelList[scope.row.ExamLevel-1].value}}</span>
            </template>
        </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button icon="wl-icon-chakan" size="mini" type="primary" @click="goLook(scope.row.id)"></el-button>
            </template>
          </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100,200,500,1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>

  <!-- 1.3 弹出层 查看日志列表 -->
      <el-dialog
        title="考试操作日志"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="1000px"
        :append-to-body="true"
        class="dialog-center-class"
        @close="cancelDialog()"
      >
        <div class="main-content-table" v-if="dialogVisible">
          <el-table
            :data="logList"
            highlight-current-row
            style="width: 100%"
          >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
             <el-table-column prop="CreateUserName" label="操作用户名"  width="120"></el-table-column>
              <el-table-column prop="SchoolName" label="操作单位"  width="200"></el-table-column>
            <el-table-column prop="OperationType" label="操作类型"  width="100"></el-table-column>
            <el-table-column prop="dateCreated" label="操作时间" width="100"></el-table-column>
            <el-table-column prop="StudentNumber" label="报考人数差" width="100">
            <template slot-scope="scope" > 
             <p v-if="scope.row.OperationType !='删除考试'"> <span>{{scope.row.StudentNumber}}</span></p>
             <span v-else>--</span>
            </template>
            </el-table-column>
            <el-table-column label="操作内容">
            <template slot-scope="scope" > 
             <p v-if="scope.row.OperationType !='删除考试'"> 报名人数：<span>{{scope.row.StudentNumberInfo}}</span></p>
             <p v-if="scope.row.OperationType !='删除考试'"> 考试等级：<span>{{scope.row.GradeInfo}}</span></p>
             <p v-if="scope.row.OperationType !='删除考试'"> 考试日期：<span>{{scope.row.ExamDateInfo}}</span></p>
             <span v-else>{{scope.row.GradeInfo}}</span>
            </template>
            </el-table-column>
            
          </el-table>
        </div>
        <div class="u-page-con">
          <el-pagination
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="page1"
            :page-sizes="[10, 20, 100, 200, 500, 1000]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount1"
            v-show="totalCount1>0"
          ></el-pagination>
        </div>
        <span slot="footer">
          <el-button size="small" @click="cancelDialog()">取消</el-button>
          <el-button size="small" type="primary" @click="addSchool()">确定</el-button>
        </span>
      </el-dialog>
    

  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible:false,
      page1: 1,
      pageSize1: 10,
      totalCount1: 0,
      logList:[],
      ExamDateId:"",
      examLevel:"",
      ExamDateList:[],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      siteList:[],
      name:"",
      committeeType:'',
      isCommittee:'',
      ExamLevelList: [
        {
          lable: '1',
          value: "初级"
        },
        {
          lable: '2',
          value: "中级"
        },
        {
          lable: '3',
          value: "高级"
        }
      ],
    };
  },
  components: {},
 
  created() {
    this.getSessionStorage();
    this.getExamSchoolList();
    this.getDateList();

  },
   computed: {
    exportExam: function() {
      return "/api/XOrg/ExamSingUpManager/exportExamExcel?title="+ this.name+"&ExamLevel="+this.examLevel+"&ExamDateId="+this.ExamDateId+"&certificateId="+this.certificateId;
    }
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    cancelDialog(){
      this.dialogVisible = false
    },
    getLog(){
      this.getExamLog();
      this.dialogVisible = true;
    },
    getExamLog(){
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getExamLog", {
          pageSize: that.pageSize1,
          page: that.page1
        })
        .then(rst => {
          that.logList = rst.list;
          that.page1 = rst.pagination.pageIndex;
          that.pageSize1 = rst.pagination.pageSize;
          that.totalCount1 = rst.pagination.totalCount;
        });
    },
    getDateList() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getDate", {
          examLevel: ""
        })
        .then(rst => {
          if (rst.code > 0) {
            that.ExamDateList = rst.dateList;           
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
     goLook(id) {
      this.$router.push({
        name: "examSingUpPrive",
        params: {
          examId: id
        }
      });
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExamSchoolList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getExamSchoolList();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getExamLog();
    },
    handleCurrentChange1(val) {
      this.page1 = val;
      this.getExamLog();
    },
    seatchSchoolList(){
      this.page = 1;
      this.getExamSchoolList();
    },
    getExamSchoolList() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamSingUpManager/getExamSchoolList", {
          title:that.name,
          ExamDateId:that.ExamDateId,
          ExamLevel:that.examLevel,
          certificateId:that.certificateId,
          pageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          that.siteList = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;

          // 参数存储本地缓存
          sessionStorage.setItem("wlx_examManager_name",that.name);
          sessionStorage.setItem("wlx_examManager_ExamDateId",that.ExamDateId);
          sessionStorage.setItem("wlx_examManager_examLevel",that.examLevel);
          sessionStorage.setItem("wlx_examManager_pageSize",that.pageSize);
          sessionStorage.setItem("wlx_examManager_page",that.page);
        });
    },
    // 获取网页缓存信息
    getSessionStorage(){
      // 获取网页缓存信息
      var name = sessionStorage.getItem("wlx_examManager_name");
      var ExamDateId = sessionStorage.getItem("wlx_examManager_ExamDateId");
      var examLevel = sessionStorage.getItem("wlx_examManager_examLevel");
      var pageSize = sessionStorage.getItem("wlx_examManager_pageSize");
      var page = sessionStorage.getItem("wlx_examManager_page");
      
      if(name != null && name != undefined){
        this.name = name;
      }
      if(ExamDateId != null && ExamDateId!= undefined && ExamDateId!="null"){
        this.ExamDateId = ExamDateId;
      }
      if(examLevel != null&& examLevel != undefined&&examLevel!="null"){
        this.examLevel = examLevel;
      }
      if(pageSize != null&&pageSize != undefined){
        this.pageSize = Number(pageSize);
      }
      if(page != null && page != undefined){
        this.page = Number(page);
      }
    },
    goExamTime(){
      this.$router.push({
        name: "examTime"
      });
    }
  }
};
</script>
<style lang="scss">
.yk-wrap-fixed{
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      height: 34px;
  }
    .wl-pagination-text{
      text-align: center;
      margin-top: 30px;
    }
    .site-manager-head-con{
      text-align: right;
    }
    .el-form-item__content{
      .el-button{
        padding: 8px 15px;
      }
    }
  }
  .wlx-site-manager-wrapper{
      .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
      }
  }
</style>
